import React from "react";
import { Container, Typography, Box, Divider } from "@mui/material";

const Technology: React.FC = () => {
  return (
    <Container maxWidth="md" style={{ marginTop: "50px", marginBottom: "80px", fontFamily: "Roboto, sans-serif", padding: "20px" }}>
      <Typography variant="h4" style={{ fontWeight: "bold", marginBottom: "8px" }}>
        Technology
      </Typography>
      <Typography variant="body1" style={{ color: "#555", marginBottom: "40px", lineHeight: 1.8 }}>
        We are transforming carbon from a climate liability into a valuable industrial resource. Our research focuses on
        efficiently separating CO&#x2082; from emissions and the atmosphere, and converting it into sustainable products.
      </Typography>

      <Divider style={{ marginBottom: "40px" }} />

      <Typography variant="h5" style={{ fontWeight: "bold", marginBottom: "24px" }}>
        Advanced Carbon Separation
      </Typography>
      <Typography variant="body1" style={{ color: "#555", marginBottom: "28px", lineHeight: 1.8 }}>
        We develop high-efficiency technologies to filter CO&#x2082; from industrial exhaust and directly from the air
        (Direct Air Capture).
      </Typography>

      <Box style={{ marginBottom: "28px" }}>
        <Typography variant="h6" style={{ fontWeight: "bold", marginBottom: "8px" }}>
          Next-Gen Filters
        </Typography>
        <Typography variant="body1" style={{ color: "#555", lineHeight: 1.8 }}>
          Using AI to design molecular sponges (Metal-Organic Frameworks) that capture CO&#x2082; molecules more effectively.
        </Typography>
      </Box>

      <Box style={{ marginBottom: "28px" }}>
        <Typography variant="h6" style={{ fontWeight: "bold", marginBottom: "8px" }}>
          Low-Energy Capture
        </Typography>
        <Typography variant="body1" style={{ color: "#555", lineHeight: 1.8 }}>
          Researching membrane and liquid-solvent systems that require less heat and electricity to operate.
        </Typography>
      </Box>

      <Divider style={{ margin: "40px 0" }} />

      <Typography variant="h5" style={{ fontWeight: "bold", marginBottom: "16px" }}>
        Our Mission
      </Typography>
      <Typography variant="body1" style={{ color: "#555", lineHeight: 1.8 }}>
        To lead the transition to a carbon-neutral economy by making CO&#x2082; capture accessible, efficient, and
        economically viable at scale.
      </Typography>
    </Container>
  );
};

export default Technology;
